/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Enable-disable 2FA security request
 */
export interface EnableDisable2FASecurityRequest {
  twoFACode?: string;
}
